/* eslint-disable @typescript-eslint/no-shadow */
import React, { useEffect } from "react";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
} from "react-router-dom";
import useSetState from "../../hooks/useSetState";
import BaseLayout from "../../components/layouts/BaseLayout";
import DevicesList from "./DevicesList/DevicesList";
import Firmware from "../firmware/Firmware";
import Config from "../config/Config";
import Companycards from "../companycards/Companycards";
import ScheduledUpdates from "../ScheduledUpdates/ScheduledUpdates";

const Devices: React.FC = () => {
  const history = useHistory();
  const tabs = [
    { label: "Devices", value: "devices" },
    { label: "Config", value: "config" },
    { label: "Firmware", value: "firmware" },
    { label: "Company Cards", value: "companycards" },
    { label: "Scheduled Updates", value: "scheduledUpdates" },
  ];

  const match = useRouteMatch({
    path: "/config/devices/:activeTabURL",
    strict: true,
    sensitive: true,
  });
  const { activeTabURL } = match?.params as any;

  const handleTabChange = (event, newValue) => {
    history.push(`/config/devices/${newValue}`);
  };

  const [{ activeTab }, setState] = useSetState({
    activeTab: "devices",
  });

  useEffect(() => {
    setState({ activeTab: activeTabURL });
  }, [activeTabURL]);

  return (
    <BaseLayout
      title="Devices"
      tabs={tabs}
      activeTab={activeTab}
      handleTabChange={handleTabChange}
    >
      <Switch>
        <Route path="/config/devices/devices" exact>
          <DevicesList />
        </Route>
        <Route path="/config/devices/config" exact>
          <Config />
        </Route>
        <Route path="/config/devices/firmware" exact>
          <Firmware />
        </Route>
        <Route path="/config/devices/companycards" exact>
          <Companycards />
        </Route>
        <Route path="/config/devices/scheduledUpdates" exact>
          <ScheduledUpdates />
        </Route>
        <Redirect to="/config/devices/devices" />
      </Switch>
    </BaseLayout>
  );
};

export default Devices;
